// Анимированная посказка input
itsoftApp.createModule("inputLabel", function() {
    $('.input__value').focusout(function() {
        if ($(this).val() !== '') {
            $(this).parent().addClass('value');
        }
        else {
            $(this).parent().removeClass('value');
        }
    });
});
